// Generated by scripts/update-seeq-icons.js from src/svg/seeq/pdf-export.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcPdfExport = {
  prefix: 'fak',
  iconName: 'pdf-export' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f952',
    'M15.4 10.2c25.6-5.1 66.6-10.2 122.8-10.2 51.2 0 92.2 10.2 117.8 30.7s41 51.2 41 92.2c0 41-15.4 71.7-35.9 92.1-30.7 30.7-71.7 46.1-128 46.1-10.2 0-20.5 0-30.7 0v143.4h-87v-394.3zM102.4 189.4c5.1 0 15.4 0 30.7 0 46.1 0 76.8-25.6 76.8-66.5 0-35.8-25.6-56.3-71.7-56.3-20.5 0-30.7 0-35.8 5.1v117.7zM358.4 10.2c30.7-5.1 76.8-10.2 117.8-10.2 76.8 0 122.9 15.4 163.8 41 41 30.7 66.6 81.9 66.6 148.4 0 76.8-25.6 128-66.6 158.8-41 35.8-107.5 51.2-184.3 51.2-46.1 0-81.9-5.1-102.4-5.2v-384zM445.4 332.8c5.1 0 20.5 0 30.8 0 81.9 0 133.1-46.1 133.1-138.2 0-81.9-46.1-128-122.9-128-20.5 0-30.7 0-41 5.1v261.1zM768 5.1h240.6v71.7h-153.6v92.2h143.4v71.6h-143.4v158.8h-87v-394.3zM778.2 762.9h-153.6v-266.3h-235.5v266.3h-153.6l271.4 261.1z',
  ],
} satisfies IconDefinition;
